module.exports = __webpack_public_path__ + "6494738c39d6f702b47e11c5c5883902.pdf";